import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { Spin } from 'antd';
import { ImpressionGrowth } from '../store/Slices/ImpressionSlice';
import { getPercentageChangeText, processChartData, sumChartData } from '../services/activity';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend
);

export function Impressionchart() {
    const dispatch = useDispatch();

    const { analytics } = useSelector((state) => state.Analytics);
    const Filter = useSelector((state) => state.Filter);
    const Sinceselector = useSelector((state) => state.SinceDates);
    const UntilSelector = useSelector((state) => state.UntilDates);

    const [InstaImpression, setInstaImpression] = useState([]);
    const [FbImpressions, setFbImpressions] = useState([]);
    const [PinterestImpression, setPinterestImpression] = useState([]);
    const [instaImpressionHistory, setInstaImpressionHistory] = useState(0);
    const [fbImpressionHistory, setfbImpressionHistory] = useState(0);
    const [pinTrestImpressionHistory, setPinstrestImpressionHistory] = useState(0);
    const [isLoader, setIsLoader] = useState(true);

    const GetImpression = useCallback(() => {
        setIsLoader(true);
      try {
        
    
        const facebookData = analytics.FACEBOOK || [];
        const instagramData = analytics.INSTAGRAM || [];
        const pinterestData = analytics.PINTEREST || [];
      
        const instaImpressions = [];
        const fbImpressions = [];
        const pinImpressions = [];
      
        let instaImpressionHistory = 0;
        let fbImpressionHistory = 0;
        let pinImpressionHistory = 0;
      
        // Instagram
        instagramData.forEach((account) => {
          account?.data?.forEach((item) => {
            if (item.name === "reach") {
              instaImpressions.push(...(item.values || []));
            }
          });
      
          account?.previousPeriod?.data?.forEach((item) => {
            if (item.name === "reach") {
              instaImpressionHistory += (item.values || []).reduce((sum, v) => sum + v, 0);
            }
          });
        });
      
        // Facebook
        facebookData.forEach((account) => {
          account?.data?.forEach((item) => {
            if (item.name === "page_impressions") {
              fbImpressions.push(...(item.values || []));
            }
          });
      
          account?.previousPeriod?.data?.forEach((item) => {
            if (item.name === "page_impressions") {
              fbImpressionHistory += (item.values || []).reduce((sum, v) => sum + v, 0);
            }
          });
        });
      
        // Pinterest
        pinterestData.forEach((account) => {
          account?.analytics?.currentPeriod?.all?.daily_metrics?.forEach((metric) => {
            if (metric.data_status === "READY") {
              pinImpressions.push({
                end_time: metric.date,
                value: metric?.metrics?.IMPRESSION || 0,
              });
            }
          });
      
          pinImpressionHistory += account?.analytics?.previousPeriod?.all?.summary_metrics?.IMPRESSION || 0;
        });
      
        // Set processed chart data
        setInstaImpression(processChartData(instaImpressions));
        setFbImpressions(processChartData(fbImpressions));
        setPinterestImpression(processChartData(pinImpressions));
      
        // Set historical values
        setInstaImpressionHistory(instaImpressionHistory);
        setfbImpressionHistory(fbImpressionHistory);
        setPinstrestImpressionHistory(pinImpressionHistory);
      
        // Calculate total
        const totalImpressions =
          sumChartData(instaImpressions) +
          sumChartData(fbImpressions) +
          pinImpressions.reduce((sum, v) => sum + v.value, 0);
         
            
        dispatch(ImpressionGrowth(totalImpressions));
      
        setIsLoader(false);
          } catch (error) {
        setIsLoader(false)
      }
      }, [analytics, dispatch]);
      

   

    useEffect(() => {
        if (Filter.length !== 0) {
            GetImpression();
        }
    }, [Sinceselector, UntilSelector, Filter, analytics, GetImpression]);

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: { grid: { display: false } },
        },
        elements: { point: { radius: 0.5 } },
        plugins: {
            legend: {
                display: true,
                position: 'bottom',
                labels: {
                    usePointStyle: true,
                    pointStyle: 'rectRounded',
                    padding: 30
                }
            }
        }
    };

    const chartData = {
        datasets: [
            {
                label: 'Instagram Impressions',
                data: InstaImpression,
                fill: true,
                borderColor: '#CE3665',
                backgroundColor: '#CE366540',
                borderWidth: 0.8,
                tension: 0.3,
            },
            {
                label: 'Facebook Impressions',
                data: FbImpressions,
                fill: true,
                borderColor: '#6F5ED3',
                backgroundColor: '#6F5ED340',
                borderWidth: 0.8,
                tension: 0.3,
            },
            {
                label: 'Pinterest Impressions',
                data: PinterestImpression,
                fill: true,
                borderColor: '#3896E3',
                backgroundColor: '#3896E340',
                borderWidth: 0.8,
                tension: 0.3,
            },
         
        ],
    };

    const getTotal = (dataArr) =>
        dataArr.reduce((acc, curr) => acc + curr.y, 0);

    return (
        <div className='chart_section'>
            <div className='chart_heading d-flex flex-column px-3 py-3'>
                <label className='label_head'>Impressions</label>
                <label className='label_sub_head'>
                    Review how your content was seen across networks during the reporting period.
                </label>
            </div>

            <div style={{ height: '40vh', padding: '40px 30px 0' }}>
                {isLoader ? (
                    <div className='d-flex align-items-center justify-content-center'>
                        <Spin />
                    </div>
                ) : (
                    <Line options={options} data={chartData} />
                )}
            </div>

            <div className='w-100 px-3'>
                <table className='w-100 table chart_table'>
                    <thead>
                        <tr>
                            <th>Impression Metrics</th>
                            <th>Totals</th>
                            <th>% Change</th>
                        </tr>
                    </thead>
                    <tbody>
  <tr>
    <td>Total Impressions</td>
    <td>
      {
        (getTotal(InstaImpression) ?? 0) +
        (getTotal(FbImpressions) ?? 0) +
        (getTotal(PinterestImpression) ?? 0)
      }
    </td>
    <td>
      
      {
        getPercentageChangeText(
                       (InstaImpression?.reduce((a, b) => a + b.y, 0) || 0) +
                       (FbImpressions?.reduce((a, b) => a + b.y, 0) || 0) +
                       (PinterestImpression?.reduce((a, b) => a + b.y, 0) || 0),
                       (instaImpressionHistory || 0) +
                       (fbImpressionHistory || 0) +
                       (pinTrestImpressionHistory || 0))
      }
    </td>
  </tr>

  <tr>
    <td>Instagram Impressions</td>
    <td>{getTotal(InstaImpression) ?? 0}</td>
    <td>
      {getPercentageChangeText(getTotal(InstaImpression) ?? 0, instaImpressionHistory)}
    </td>
  </tr>

  <tr>
    <td>Facebook Impressions</td>
    <td>{getTotal(FbImpressions) ?? 0}</td>
    <td>
      {getPercentageChangeText(getTotal(FbImpressions) ?? 0, fbImpressionHistory)}
    </td>
  </tr>

  <tr>
    <td>Pinterest Impressions</td>
    <td>{getTotal(PinterestImpression) ?? 0}</td>
    <td>
      {getPercentageChangeText(getTotal(PinterestImpression) ?? 0, pinTrestImpressionHistory)}
    </td>
  </tr>
</tbody>


                </table>
            </div>
        </div>
    );
}